import React, { useState, useRef } from 'react'
import parse from 'html-react-parser'
import { Link } from 'react-router-dom'
import { CSVLink } from 'react-csv'

//styles
import '../pages/Kaiwa.css'
import './SearchResult.css'

// convert segment to value for sorting purposes 
// e.g 5-1 -> 501 
const segmentToValue = (segment) => (parseInt(segment.split('-')[0]) * 100 + parseInt(segment.split('-')[1]))

// given an array arr, check whether arr contains at least one of the values in the array values
const containsAtLeastOne = (arr, values) => values.some(value => arr.includes(value))

const applyFormatting = (domNode, particle, particles, particleType) => {
    if (
        domNode.attribs &&
        domNode.attribs.class &&
        domNode.children[0] &&
        (   // handle both one and multiple particles
            (!particles && particle === domNode.children[0].data) ||
            (particles && particles.includes(domNode.children[0].data))
        )
    ) {
        if (
            domNode.attribs.class === 'kakari-style' &&
            particleType === 'kakari'
        ) {
            return <span className={'kakari-style-highlight'}>{domNode.children[0].data}</span>;
        } else if (
            domNode.attribs.class === 'teidai-style' &&
            particleType === 'teidai'
        ) {
            return <span className={'teidai-style-highlight'}>{domNode.children[0].data}</span>;
        } else if (
            domNode.attribs.class === 'kaku-style' &&
            particleType === 'kaku'
        ) {
            return <span className={'kaku-style-highlight'}>{domNode.children[0].data}</span>;
        } else if (
            domNode.attribs.class === 'sentence-final-style' &&
            particleType === 'sentence-final'
        ) {
            return <span className={'sentence-final-style-highlight'}>{domNode.children[0].data}</span>;
        } else if (
            domNode.attribs.class === 'setsuzoku-style' &&
            particleType === 'setsuzoku'
        ) {
            return <span className={'setsuzoku-style-highlight'}>{domNode.children[0].data}</span>;
        } else if (
            domNode.attribs.class === 'juntai-style' &&
            particleType === 'juntai'
        ) {
            return <span className={'juntai-style-highlight'}>{domNode.children[0].data}</span>;
        }
    }
}


export default function SearchResult({ data, particle, particleType, minKaiwaSegment, maxKaiwaSegment }) {
    const results = []
    let totalHits = 0
    const [isTableVisible, setIsTableVisible] = useState(false)
    const tooltipRef = useRef();

    const typeMap = {
        "kakari": { "key": "kakari_particles", "delimiter": "&" },
        "teidai": { "key": "teidai_particles", "delimiter": "!" },
        "kaku": { "key": "kaku_particles", "delimiter": "*" },
        "sentence-final": { "key": "sentence_final_particles", "delimiter": "#" },
        "setsuzoku": { "key": "setsuzoku_particles", "delimiter": "+" },
        "juntai": { "key": "juntai_particles", "delimiter": "$" },
        "all-words": { "key": "all_words", "delimiter": " " },
    }

    // check for multiple particles in particle
    // they would be delimited by a slash
    let particles = particle.includes('/') ? particle.split('/') : null

    for (let row of data) {
        if (
            ( // if one particle, check for existence.  if multiple particles, check each
                (!particles && row[typeMap[particleType].key].includes(particle)) ||
                (particles && containsAtLeastOne(row[typeMap[particleType].key], particles))
            ) &&
            segmentToValue(row["kaiwa_segment"]) >= segmentToValue(minKaiwaSegment) &&
            segmentToValue(row["kaiwa_segment"]) <= segmentToValue(maxKaiwaSegment)
        ) {
            row["formatted"] = row.html
            results.push(row)
            if (particles) {
                for (let p of particles) {
                    totalHits += row[typeMap[particleType].key].filter((el) => el === p).length
                }
            } else {
                totalHits += row[typeMap[particleType].key].filter((el) => el === particle).length
            }
        }
    }

    // sort results
    results.sort((a,b) => a.id - b.id)

    // Pull out relevant data for the csv export file
    let csvResults = results.map((result) => [result.kaiwa_segment, result.speaker, result.raw_text, result.jp_translation])
    // Add header row
    csvResults.unshift(["Kaiwa", "Speaker", "Okinawan", "Japanese"])

    return (
        <div className='container-md'>
            <div className='row'>
                {results.length > 0 && <p className='result-report col-md-1 px-0'>{totalHits}件</p>}
                {results.length > 0 && <div className='col-md-6' />}
                {results.length > 0 &&
                    <div className="form-check form-switch text-end col-auto result-report">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id="table-view"
                            onChange={() => setIsTableVisible(!isTableVisible)}
                        />
                        <label
                            className="form-check-label"
                            htmlFor="table-view"
                            ref={tooltipRef}
                        >テーブル表示</label>
                    </div>
                }
                {results.length > 0 && <div className='col-md-2'>
                    <CSVLink 
                        data={csvResults}
                        filename={`okinawan_corpus_search_results_${particle}.csv`}
                    >CSV ダウンロード</CSVLink></div>}
            </div>
            { // Visible portion used to display results
                !isTableVisible &&
                results.length > 0 &&
                results.map(result => (
                    <div key={result.id} className='row'>
                        <div className='card-group mb-3 col-md-10 px-0'>
                            <div className='card border-dark'>
                                <div className='card-header text-bg-light'>
                                    <Link to={`/kaiwa/${result.kaiwa_segment}`}>{result.kaiwa_segment}</Link> {result.speaker}
                                </div>
                                <div className='card-body'>
                                    <p className="result-text">
                                        { // particle-based search (i.e. a specific particleType is specified) 
                                            particleType !== 'all-words' &&
                                            parse(result.html, { replace: domNode => applyFormatting(domNode, particle, particles, particleType) })
                                        }
                                        {   // search for all words, requires a regex replacement of the specific word 
                                            particleType === 'all-words' &&
                                            parse(result.html.replace(new RegExp(` ${particle} `, 'g'), `<span class='all-words-style-highlight'> ${particle} </span>`))

                                            // TODO: if all-words highlighting for multiple particles is needed, add here
                                        }
                                    </p>
                                </div>
                            </div>
                            <div className='card border-dark'>
                                <div className='card-header text-bg-light'>日本語訳</div>
                                <div className='card-body'>
                                    <p className="result-text">
                                        { parse(result.jp_translation) }
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}

            <div className='row'>
                <table className='col-md-10'>
                    <tbody>
                        { // HTML table version of the data for copying into Word, Excel etc. 
                            isTableVisible &&
                            results.length > 0 &&
                            results.map(result => (
                                <tr key={result.id}>
                                    <td>{result.kaiwa_segment}</td>
                                    <td>{result.speaker}</td>
                                    <td>
                                        { // particle-based search (i.e. a specific particleType is specified) 
                                            particleType !== 'all-words' &&
                                            parse(result.html, { replace: domNode => applyFormatting(domNode, particle, particles, particleType) })
                                        }
                                        {   // search for all words, requires a regex replacement of the specific word 
                                            particleType === 'all-words' &&
                                            parse(result.html.replace(new RegExp(particle, 'g'), `<span class='all-words-style-highlight'>${particle}</span>`))
                                        }
                                    </td>
                                    <td>{parse(result.jp_translation)}</td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>

            {results.length === 0 && <span>No results!</span>}

        </div>
    )
}
